import { api } from "api/api";
import { Dialog } from "primereact/dialog";
import FirebasePdfService from "service/FirabasePdfService";

type Props = {
    visible: boolean;
    onHide: () => void;
    url: string;
}

const firebasePdfService = new FirebasePdfService();
export default function ModalVerPdf(props: Props) {
    return (
        <Dialog header="Visualizar PDF" visible={props.visible} style={{ width: '80vw', height: '80vh' }} baseZIndex={9999} onHide={props.onHide} blockScroll={true}>
            <iframe
                title="Visualizador de PDF"
                src={firebasePdfService.getPdfUrl(props.url)}
                style={{ width: '100%', height: "100%", border: 'none' }}
            />
        </Dialog>
    )
}